import { render, staticRenderFns } from "./CAxAFSMxClarificationsPage.vue?vue&type=template&id=266e4e22"
import script from "./CAxAFSMxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFSMxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFSMxClarificationsPage.vue?vue&type=style&index=0&id=266e4e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports